import React, { useEffect } from "react";
import SignInSection from "./../components/SignInSection";
import { useAuth } from "util/auth.js";
import { useRouter } from "util/router.js";

function SigninPage(props) {

  const auth = useAuth();
  const router = useRouter();
  // Redirect to /signin
  // if not signed in.
  useEffect(() => {
    if (auth.user && !auth.user.isAnonymous) {
      router.push("/dashboard");
    }
  }, [auth, router]);

  return (
    <SignInSection
      bg="white"
      textColor="dark"
      size="md"
      bgImage=""
      bgImageOpacity={1}
      title="Welcome back"
      subtitle=""
      buttonText="Sign in"
      inputSize="lg"
    ></SignInSection>
  );
}

export default SigninPage;
